/**
 * Mock data for View Occupancy page
 * Backend developer will replace with actual API calls
 */

// Column options for View Occupancy - matches screenshot exactly
export const COLUMN_OPTIONS = [
  { id: "column-unit", label: "Unit", defaultChecked: true },
  { id: "column-condo", label: "Condo", defaultChecked: true },
  { id: "column-lessee", label: "Lessee", defaultChecked: true },
  { id: "column-lessor", label: "Lessor", defaultChecked: true },
  { id: "column-capacity", label: "Capacity", defaultChecked: true },
  { id: "column-staff-occupants", label: "Staff Occupants", defaultChecked: true },
  { id: "column-non-staff-occupants", label: "Non-Staff Occupants", defaultChecked: true },
  { id: "column-total-occupants", label: "Total Occupants", defaultChecked: false },
  { id: "column-occupants-history", label: "Occupants History", defaultChecked: true },
  { id: "column-active", label: "Active", defaultChecked: true },
  { id: "column-address", label: "Address", defaultChecked: true },
  { id: "column-location", label: "Location", defaultChecked: true },
  { id: "column-room-count", label: "Room Count", defaultChecked: true },
  { id: "column-parking-slot", label: "Parking/Spot", defaultChecked: true },
  { id: "column-maid-name", label: "Maid Name", defaultChecked: false },
  { id: "column-unit-phone", label: "Unit Phone Number", defaultChecked: false },
  { id: "column-unit-leader", label: "Unit Leader", defaultChecked: false },
  { id: "column-rental-start", label: "Rental Start Date", defaultChecked: false },
  { id: "column-rental-end", label: "Rental End Date", defaultChecked: false },
  { id: "column-furnish-type", label: "Furnish Type", defaultChecked: true },
  { id: "column-broker-name", label: "Broker Name", defaultChecked: false },
  { id: "column-broker-email", label: "Broker Email", defaultChecked: false },
  { id: "column-maid-contact", label: "Maid Contact", defaultChecked: true },
  { id: "column-occupants-names", label: "Occupant's Names", defaultChecked: false },
  { id: "column-condo-company", label: "Condo Company", defaultChecked: true },
  { id: "column-condo-sharing", label: "Condo Sharing", defaultChecked: true }
];

// Filters for View Occupancy page - different from Condo Units
export const FILTERS = [
  {
    id: "filter-condo",
    label: "Condo",
    defaultValue: "all",
    options: [
      { value: "all", label: "All condos" },
      { value: "oriental", label: "Oriental KH" },
      { value: "141", label: "141 Apartment" },
      { value: "three-central", label: "Three Central" }
    ]
  },
  {
    id: "filter-lessor",
    label: "Lessor",
    defaultValue: "all",
    options: [
      { value: "all", label: "All lessors" },
      { value: "jk", label: "JK" },
      { value: "steven-tao", label: "Steven Tao" },
      { value: "lcg", label: "LCG" },
      { value: "ivan", label: "Ivan Christopher Legaspi" }
    ]
  },
  {
    id: "filter-condo-unit",
    label: "Condo Unit",
    defaultValue: "all",
    options: [
      { value: "all", label: "All units" },
      { value: "141-apartment", label: "141 Apartment" },
      { value: "2368-makelo", label: "2368 Makelo St." },
      { value: "28f-three-central", label: "28F Three Central" },
      { value: "68-philip-street", label: "68 Philip Street Manansala Village, Paranaque City" }
    ]
  },
  {
    id: "filter-lessee",
    label: "Lessee",
    defaultValue: "all",
    options: [
      { value: "all", label: "All lessees" },
      { value: "jk", label: "JK" },
      { value: "steven-tao", label: "Steven Tao" },
      { value: "tierra", label: "Tierra International Construction" },
      { value: "ivan", label: "Ivan Christopher Legaspi" }
    ]
  },
  {
    id: "filter-active",
    label: "Active",
    defaultValue: "yes",
    options: [
      { value: "all", label: "All" },
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" }
    ]
  },
  {
    id: "filter-condo-company",
    label: "Condo Company",
    defaultValue: "none",
    options: [
      { value: "none", label: "None selected" },
      { value: "concerto", label: "Concerto" },
      { value: "cepo", label: "Cepo" },
      { value: "north", label: "North Holdings" }
    ]
  },
  {
    id: "filter-condo-sharing",
    label: "Condo Sharing",
    defaultValue: "all",
    options: [
      { value: "all", label: "All" },
      { value: "shared", label: "Not Shared" },
      { value: "not-shared", label: "Shared" }
    ]
  },
  {
    id: "filter-assigned",
    label: "Assigned",
    defaultValue: "all",
    options: [
      { value: "all", label: "All" },
      { value: "assigned", label: "Assigned" },
      { value: "unassigned", label: "Unassigned" }
    ]
  },
  {
    id: "filter-allowance",
    label: "Allowance",
    defaultValue: "all",
    options: [
      { value: "all", label: "All" },
      { value: "with", label: "With allowance" },
      { value: "without", label: "Without allowance" }
    ]
  }
];

// Occupancy data rows - based on screenshot
export const OCCUPANCY_ROWS = [
  {
    id: "141-apartment",
    unit: "141 Apartment",
    condo: "141 Apartment",
    lessee: "JK",
    lessor: "Samhoan Sivutha",
    capacity: 0,
    staffOccupants: 1,
    nonStaffOccupants: 0,
    totalOccupants: 1,
    activeLabel: "Yes",
    activeStatus: "success",
    condoCompany: "Concerto",
    condoSharing: "Not Shared"
  },
  {
    id: "2368-makelo",
    unit: "2368 Makelo St.",
    condo: "Osmanthus Village",
    lessee: "Steven Tao",
    lessor: "Tierra International Construction",
    capacity: 0,
    staffOccupants: 0,
    nonStaffOccupants: 0,
    totalOccupants: 0,
    activeLabel: "Yes",
    activeStatus: "success",
    condoCompany: "Cepo",
    condoSharing: "Not Shared"
  },
  {
    id: "28f-three-central",
    unit: "28F Three Central",
    condo: "Three Central",
    lessee: "LCG",
    lessor: "NIMANCEL LAN",
    capacity: 2,
    staffOccupants: 1,
    nonStaffOccupants: 0,
    totalOccupants: 1,
    activeLabel: "Yes",
    activeStatus: "success",
    condoCompany: "Cepo",
    condoSharing: "Not Shared"
  },
  {
    id: "68-philip-street",
    unit: "68 Philip Street Manansala Village, Paranaque City",
    condo: "Ivan Christopher Legaspi",
    lessee: "Ousan Solution Inc.",
    lessor: "Ivan Christopher Legaspi",
    capacity: 0,
    staffOccupants: 0,
    nonStaffOccupants: 0,
    totalOccupants: 0,
    activeLabel: "Yes",
    activeStatus: "success",
    condoCompany: "Cepo",
    condoSharing: "Not Shared"
  }
];
